import request from '@/utils/request'

export function getUser() {
  return request({
    url: 'me',
    method: 'get'
  })
}

export function checkout(items, address_id) {
  return request({
    url: 'orders',
    method: 'post',
    data: { items, address_id }
  })
}
